import styled from 'styled-components'

export default styled.div`
  color: black;
  margin-top: 117px;
  .sorry-message {
  }

  .keyword {
    margin-top: 14px;
    margin-bottom: 14px;
  }

  .sorry-message, .keyword {
    font-family: 'ABChanel PB Regular L', Arial, sans-serif;
    font-size: 18px;
    line-height: 1.11;
    letter-spacing: -0.3px;
    text-align: center;
  }

  .retry-message {
    margin-top: 36px;
    font-family: 'ABChanel PB Regular L', Arial, sans-serif;
    font-size: 13px;
    line-height: 1.24em;
    letter-spacing: -0.2px;
    text-align: center;
  }
`



// WEBPACK FOOTER //
// ./src/styles/EmptyProductSearchResult.js